<template>
  <DashboardWidgetGauge class="widget-roe" :loading="loading" title="ROE | Return on Equity" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-roe',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 5,
    },
    max: {
      type: Number,
      default: 8,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
